import Link from '@decisiv/ui-components/lib/components/Link';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function AccountNameCell({
  rowData: { platformAccount },
}: CellProps) {
  return (
    <Link
      to={ROUTE_NAMES.forAdminManagementAccount(platformAccount?.id)}
      text={platformAccount?.name}
    />
  );
}
